import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  centered: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    marginTop: rem(50),
    // margin: "auto",
  },
  update: {
    color: "#fff",
    fontWeight: 600,
    textDecoration: "none",
    borderBottom: "1px solid #fff",
  },
  title: {
    fontSize: rem(34),
    fontWeight: 700,
    fontFamily: "Inter",
    marginBottom: rem(10),
  },
  paymentFailedBox: {
    background: "#ff00009e",
    color: "#FFFF",
    padding: 20,
    borderRadius: 10,
    // marginTop: 10,
    marginBottom: 10,
    fontFamily: "Inter",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  description: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797",
  },
  logo: {
    marginTop: rem(30),
    marginBottom: rem(40),
  },
  type: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#97979726",
    borderStyle: "solid",
    padding: 20,
  },
  selected: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#FFBA45",
    borderStyle: "solid",
    padding: 20,
  },
  myfont: {
    fontFamily: "Inter",
  },
  card: {
    width: "100%",
    marginTop: 0,
    overflow: "unset",
  },
  payBtn: {
    marginTop: 14,
    width: "100%",
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  m10: {
    marginTop: rem(10),
    marginBottom: rem(10),
  },
  font1: {
    fontSize: rem(20),
    fontWeight: 500,
    fontFamily: "Inter",
    cursor: "pointer",
  },
  font2: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797",
  },
  back: {
    position: "absolute",
    top: rem(50),
    left: rem(50),
    fontSize: rem(16),
    fontFamily: "Inter",
    fontWeight: 500,
    "@media (max-width: 1024px)": {
      top: rem(100),
    },
  },
  plaidComponent: {
    // cursor: "pointer",
    border: "1px solid #F2F2F2",
    borderRadius: "10px",
    width: "65%",
    "@media (max-width: 900px)": {
      width: "80%",
    },
    "@media (max-width: 768px)": {
      width: "90%",
    },
  },
  connectBankImage: {
    width: "30%",
    "@media (max-width: 500px)": {
      width: "100%",
    },
  },
  insideFlex: {
    width: "60%",
    "@media (max-width: 500px)": {
      width: "95%",
      padding: "10px",
    },
  },
  marginTop: {
    "@media (max-width:992px)": {
      marginTop: "15px",
    },
  },
  paymentPageBox: {
    width: "100%",
    height: "fit-content",
  },
  paymentPageBoxLeft: {
    padding: "30px 40px",
    width: "50%",
    backgroundColor: "#FCFCFC",
    minHeight: "100vh",
    maxHeight: "fit-content",
  },
  paymentPageBoxRight: {
    width: "50%",
    padding: "30px 40px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    maxHeight: "fit-content",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    "& > h4": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 20,
      fontSize: 24,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#101828",
      textAlign: "center",
      margin: 0,
      marginBottom: 32,
      "& svg": {
        color: "#000000",
      },
    },
  },
  inputFieldStyle: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#404040",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "10px 14px",
      height: 44,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      background: "#FFF",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      "& input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",

        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "#171717",
          transition: "background-color 5000s ease-in-out 0s",
        },

        "&::placeholder": {
          color: "#737373",
        },
      },
    },
  },
  agreeTermsCondText: {
    margin: 0,
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#84949E",
    "& a": {
      color: "#FFAF4A",
      textDecoration: "none",
    },
  },
  paymentPageBoxBackBtn: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Inter",
    gap: 8,
    fontSize: 16,
    fontWeight: 500,
    color: "#171717",
    marginBottom: 10,
  },
  paymentPageBoxLogo: {
    width: 160,
    marginTop: 20,
  },
}));
